import { NgModule } from "@angular/core";

import { sharedModule } from "src/app/shared/shared.module";
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";
import { FormsModule } from "@angular/forms";
import { SubsidiaryCompanyComponent } from "./subsidiary-company/subsidiary-company.component";
import { SubsidiaryMemorandumComponent } from './subsidiary-memorandum/subsidiary-memorandum.component';
import { SubsidiaryContractComponent } from './subsidiary-contract/subsidiary-contract.component';
import { SubsidiaryCompanyListComponent } from './subsidiary-company/subsidiary-company-list/subsidiary-company-list.component';
import { SubsidiaryCompanyEntryComponent } from './subsidiary-company/subsidiary-company-entry/subsidiary-company-entry.component';
import { SubsidiaryContractListComponent } from './subsidiary-contract/subsidiary-contract-list/subsidiary-contract-list.component';
import { SubsidiaryContractEntryComponent } from './subsidiary-contract/subsidiary-contract-entry/subsidiary-contract-entry.component';
import { SubsidiaryMemorandumListComponent } from './subsidiary-memorandum/subsidiary-memorandum-list/subsidiary-memorandum-list.component';
import { SubsidiaryMemorandumEntryComponent } from './subsidiary-memorandum/subsidiary-memorandum-entry/subsidiary-memorandum-entry.component';
import { SubsidiaryCompanyAgentComponent } from './subsidiary-company-agent/subsidiary-company-agent.component';
import { SubsidiaryCompanyAgentListComponent } from "./subsidiary-company-agent/subsidiary-company-agent-list/subsidiary-company-agent-list.component";
import { SubsidiaryCompanyAgentEntryComponent } from "./subsidiary-company-agent/subsidiary-company-agent-entry/subsidiary-company-agent-entry.component";
import { SubsidiaryStudentsComponent } from './subsidiary-students/subsidiary-students.component';
import { SubsidiaryPlacementEntryComponent } from './subsidiary-placement-entry/subsidiary-placement-entry.component';
import { SubsidiaryClassesComponent } from './subsidiary-classes/subsidiary-classes.component';
import { SubsidiaryRegisterEntryComponent } from './subsidiary-register-entry/subsidiary-register-entry.component';
import { SubsidiaryPlacementInvoiceComponent } from './subsidiary-placement-invoice/subsidiary-placement-invoice.component';
import { SubsidiaryRegistrationInvoiceComponent } from './subsidiary-registration-invoice/subsidiary-registration-invoice.component';

@NgModule({
  declarations: [
    SubsidiaryCompanyComponent,
    SubsidiaryMemorandumComponent,
    SubsidiaryContractComponent,
    SubsidiaryCompanyListComponent,
    SubsidiaryCompanyEntryComponent,
    SubsidiaryContractListComponent,
    SubsidiaryContractEntryComponent,
    SubsidiaryMemorandumListComponent,
    SubsidiaryMemorandumEntryComponent,
    SubsidiaryCompanyAgentComponent,
    SubsidiaryCompanyAgentListComponent,
    SubsidiaryCompanyAgentEntryComponent,
    SubsidiaryStudentsComponent,
    SubsidiaryPlacementEntryComponent,
    SubsidiaryClassesComponent,
    SubsidiaryRegisterEntryComponent,
    SubsidiaryPlacementInvoiceComponent,
    SubsidiaryRegistrationInvoiceComponent
  ],
  imports: [sharedModule,FormsModule],
  entryComponents: [
    AlertDialogComponent,
    SubsidiaryCompanyEntryComponent,
    SubsidiaryContractEntryComponent,
    SubsidiaryMemorandumEntryComponent,
    SubsidiaryCompanyAgentEntryComponent,
    SubsidiaryPlacementEntryComponent,
    SubsidiaryRegisterEntryComponent,
    SubsidiaryPlacementInvoiceComponent,
    SubsidiaryRegistrationInvoiceComponent
  ]
})
export class SubsidiaryModule {}
